import React from 'react'
import { CandidatePool } from 'src/components/candidate-pool/CandidatePool'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'

export const CandidatePoolPage = () => {
  return (
    <ReloadWrapper>
      <div data-testid="dashboard-candidate-pool-page">
        <CandidatePool />
      </div>
    </ReloadWrapper>
  )
}
